// extracted by mini-css-extract-plugin
export default {"menuBlock":"dH-z","title":"eH-z","nav":"fH-z","flexCell":"gH-z","facetLink":"hH-z"};